import React, { useState, useEffect, useId } from "react";

export default function ProgRing(props) {
  const gradientId = useId(); // unique per instance
  const [animatedValue, setAnimatedValue] = useState(0);

  let percentage = props.value;
  let col_1, col_2, textcolor;

  if (percentage === undefined || percentage === -1) {
    col_1 = "#D7D7D7";
    col_2 = "#878787";
    textcolor = "#BABEC1";
    percentage = 100;
  } else if (percentage === 0) {
    col_1 = "green";
    col_2 = "lime";
    textcolor = "lime";
    percentage = 100;
  } else if (percentage > 0 && percentage < 40) {
    col_1 = "#34D831";
    col_2 = "#B1FB77";
    textcolor = "#B1FB77";
  } else if (percentage >= 40 && percentage < 75) {
    col_1 = "#FFDD65";
    col_2 = "#FB9C45";
    textcolor = "#FB9C45";
  } else if (percentage >= 75 && percentage < 100) {
    col_1 = "#EE9543";
    col_2 = "#EE5A45";
    textcolor = "#EE5A45";
  } else {
    col_1 = "#DE3635";
    col_2 = "#ED9243";
    textcolor = "#DE3635";
  }

  useEffect(() => {
    if (props.value === undefined || props.value === -1) {
      setAnimatedValue(100);
      return;
    }
    let start = 0;
    const duration = props.duration ?? 1000; // allow per-ring durations
    const stepMs = 10;
    const increment = percentage / (duration / stepMs);
    const interval = setInterval(() => {
      start += increment;
      setAnimatedValue((prev) => (start >= percentage ? percentage : start));
      if (start >= percentage) clearInterval(interval);
    }, stepMs);
    return () => clearInterval(interval);
  }, [props.value, percentage, props.duration]); // depend on the actual value

  const ringSize = props.size || 160;

  // SVG circular progress bar geometry
  const viewBoxSize = 100;
  const strokeWidth = 12;
  const radius = (viewBoxSize - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const clampedValue = animatedValue < 100 && animatedValue > 95 ? 95 : animatedValue;
  const dashOffset = circumference * (1 - clampedValue / 100);

  const displayText =
    props.showText === false
      ? ""
      : (percentage === 100 && props.value === -1) || props.value === undefined
        ? "?"
        : String(props.value);

  return (
    <div className="rating-pir">
      <div
        style={{ height: ringSize, width: ringSize }}
        className="ring"
      >
        <svg viewBox={`0 0 ${viewBoxSize} ${viewBoxSize}`}>
          <defs>
            <linearGradient id={gradientId} gradientTransform="rotate(360)">
              <stop offset="0" stopColor={col_1} />
              <stop offset="100%" stopColor={col_2} />
            </linearGradient>
          </defs>
          {/* Trail (background circle) */}
          <circle
            cx={viewBoxSize / 2}
            cy={viewBoxSize / 2}
            r={radius}
            fill="none"
            stroke="#00345b"
            strokeWidth={strokeWidth}
          />
          {/* Progress arc */}
          <circle
            cx={viewBoxSize / 2}
            cy={viewBoxSize / 2}
            r={radius}
            fill="none"
            stroke={`url(#${gradientId})`}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeDasharray={circumference}
            strokeDashoffset={dashOffset}
            transform={`rotate(-90 ${viewBoxSize / 2} ${viewBoxSize / 2})`}
          />
          {/* Center text */}
          {displayText && (
            <text
              x={viewBoxSize / 2}
              y={viewBoxSize / 2}
              dominantBaseline="central"
              textAnchor="middle"
              fill={textcolor}
              fontSize="20px"
              fontWeight={700}
            >
              {displayText}
            </text>
          )}
        </svg>
      </div>
    </div>
  );
}
